import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton", "spinner", "cancelButton"];
  static outlets = ["dialog"];

  connect() {
    this.isLoading = false;
  }

  toggleLoading(loading) {
    if (this.isLoading === loading) return;

    this.isLoading = loading;

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = loading;
      if (this.hasSpinnerTarget) {
        this.spinnerTarget.classList.toggle("hidden", !loading);
      }
    }

    if (this.hasCancelButtonTarget) {
      this.cancelButtonTarget.disabled = loading;
    }

    if (this.hasDialogOutlet) {
      this.dialogOutlet.setLoadingState(loading);
    }
  }

  formSubmit() {
    this.toggleLoading(true);
  }

  formSubmitEnd() {
    this.toggleLoading(false);
  }
}
